<template>
  <transition name="s_popup_transition">
    <div class="transfer_notifier_wrapper" v-if="!hidden && isDisplayed">
      <div class="transfer_notifier">
        <div class="transfer_notifier_coin"></div>
        <span class="transfer_notifier_text">{{
          (remoteConfig && remoteConfig.transfer.notifierText) ||
          "Congrats! You have received Loyalty points from your colleague."
        }}</span>
        <a class="right-btn" @click="openHistory">{{
          (remoteConfig && remoteConfig.transfer.notifierButton) ||
          "Learn more!"
        }}</a>
        <a class="close" @click="close"></a>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
import Cookies from "js-cookie";

const HISTORY_LAST_VIEWED_COOKIE = "HISTORY_LAST_VIEWED";

export default {
  name: "AppPopupTransferNotifier",
  data() {
    return {
      lastViewedCookie: undefined,
      hidden: false,
    };
  },
  computed: {
    ...mapGetters(["currentHistory", "remoteConfig"]),
    isDisplayed() {
      let lastViewed = this.$moment(this.lastViewedCookie);
      return (
        this.currentHistory &&
        this.currentHistory.filter(
          (v) =>
            v.action === "points_transfer" &&
            v.points_delta > 0 &&
            (!lastViewed.isValid() ||
              this.$moment(v.action_date).diff(lastViewed) > 0)
        ).length
      );
    },
  },
  methods: {
    openHistory() {
      this.$eventBus.$emit("popup", "history");
      this.close();
    },
    close() {
      this.hidden = true;
      Cookies.set(
        HISTORY_LAST_VIEWED_COOKIE,
        this.currentHistory[0].action_date
      );
    },
  },
  mounted() {
    this.lastViewedCookie = Cookies.get(HISTORY_LAST_VIEWED_COOKIE) || "";
    this.$eventBus.$on("popup", this.close);
  },
};
</script>